import { render, staticRenderFns } from "./SundryItemOrderDetailsView.vue?vue&type=template&id=a029cc6a&"
import script from "./SundryItemOrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./SundryItemOrderDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports